module.exports = __webpack_public_path__ + "static/media/bmi.f292125e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/bmi.svg
// module id = 1460
// module chunks = 0